import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import AAMCAPPFeatures from "./AAMCAPPFeatures";
import AAMCAPPBenefits from "./AAMCAPPBenefits";

// Main component for AAMC APP
export default function AAMCAPP() {
  // Overview data sections
  const data1 = [
    "Contract Farming: AAMC app integrates contract farming services for streamlined agricultural operations.",
    "Farm Management: Oversees daily farm operations, including crop production, livestock care, resource allocation, and budgeting to maximize efficiency and profitability.",
  ];

  const data2 = [
    "AgriAsset Inventory: Tracks and manages agricultural assets like equipment, livestock, crops, and land to ensure optimal usage, timely maintenance, and efficient resource allocation.",
    "Investable AgriAsset Management: Focuses on agricultural assets with investment potential, optimizing them for value appreciation, investor attraction, and long-term financial returns.",
  ];

  return (
    <>
      {/* Banner with Download Option */}
      <UpdatesBanner
        DlBtn="true"
        className="sdh-bg"
        bannerTitle={["AAMC APP"]}
        DownloadText="Download App"
        dlLink="https://play.google.com/store/apps/details?id=com.gbrapp.aamcapp&hl=en&gl=US"
      />

      {/* Solution Overview */}
      <SolutionEcosystem title="Overview" type="AAMCAPP" />

      {/* Overview Feature  */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/*  Features & Benefits  Section*/}
      <AAMCAPPFeatures />
      <AAMCAPPBenefits />
    </>
  );
}

